import React, { useEffect, useState } from "react";
import { StyledContainer } from "./styles";
import { db } from "../../Firebase.js";
import { useHistory } from "react-router-dom";
import { sendAppEvent } from "../../Utils";
import { Button } from "../Button";
import InlineSVG from "react-inlinesvg";

export default function NewUserShadowPage() {
  const history = useHistory();
  const [docId, setDocId] = useState(null);
  const [interviewLink, setInterviewLink] = useState("");
  const [loadedInterviewLink, setLoadedInterviewLink] = useState(false);

  useEffect(() => {
    const unsub = db
      .collection("newUserInterviews")
      .limit(1)
      .onSnapshot((snap) => {
        if (!snap.docs.length) {
          return;
        }
        const doc = snap.docs[0];
        const link = doc.get("newInterviewLink");
        setInterviewLink(link || "");
        setDocId(doc.id);
        setLoadedInterviewLink(true);
      });
    return unsub;
  }, []);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (loadedInterviewLink && !interviewLink) {
      if (urlParams.has("next")) {
        history.push(decodeURIComponent(urlParams.get("next")));
      } else {
        history.push("/app");
      }
    } else if (interviewLink) {
      sendAppEvent("new_user_shadow_viewed");
    }
  }, [loadedInterviewLink, interviewLink, history]);

  function handleInterviewLink(join) {
    if (join) {
      db.collection("newUserInterviews").doc(docId).update({ newInterviewLink: "" });
      window.open(interviewLink, "_blank");
      sendAppEvent("new_user_shadow_joined");
    } else {
      sendAppEvent("new_user_shadow_skipped");
    }
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("next")) {
      history.push(decodeURIComponent(urlParams.get("next")));
    } else {
      history.push("/app");
    }
  }

  if (!interviewLink) {
    return <div></div>;
  }
  return (
    <StyledContainer id="intake-survey">
      <NewUserShadow onButtonClick={handleInterviewLink} />
    </StyledContainer>
  );
}

export function NewUserShadow({ onButtonClick }) {
  return (
    <div className="interview-offer">
      <h1 className="headline">Help us improve Sudowrite!</h1>
      <p>We're looking for authors like you to share your thoughts in a 30-minute Zoom call. You'll receive $60 for your time.</p>
      <ul className="benefits-list">
        <li>
          <InlineSVG src="/assets/check-simple.svg" /> No preparation or experience needed. There are no wrong answers.
        </li>
        <li>
          <InlineSVG src="/assets/check-simple.svg" /> Your feedback directly influences product improvements
        </li>
        <li>
          <InlineSVG src="/assets/check-simple.svg" /> Limited spots available today
        </li>
        <li>
          <InlineSVG src="/assets/check-simple.svg" /> $60 Amazon gift card sent immediately after the call
        </li>
      </ul>
      <div className="button-row">
        <Button
          onClick={() => onButtonClick(false)}
          tertiary={true}
        >
          No thanks
        </Button>
        <Button
          primary={true}
          onClick={() => onButtonClick(true)}
        >
          Join Zoom Call Now
        </Button>
      </div>
    </div>
  );
}
